import { render, staticRenderFns } from "./JaasIframe.vue?vue&type=template&id=dcab846e&scoped=true&"
import script from "./JaasIframe.vue?vue&type=script&lang=js&"
export * from "./JaasIframe.vue?vue&type=script&lang=js&"
import style0 from "./JaasIframe.vue?vue&type=style&index=0&id=dcab846e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcab846e",
  null
  
)

export default component.exports